// constants
import { GROUP_BY_FILTER_OPTIONS } from 'src/constants'

export const MONITORING_MANAGEMENT_DEFAULT_SORT = {
  sortedColumn: 'caseManager',
  sortedColumnOrder: 'ascend'
}

const MONITORING_MANAGEMENT_OPTIONS = ['caseManager', 'facility', 'group']

export const MONITORING_MANAGEMENT_GROUP_BY_FILTER_OPTIONS =
  GROUP_BY_FILTER_OPTIONS.filter(({ value }) =>
    MONITORING_MANAGEMENT_OPTIONS.includes(value)
  )
